import axios from 'axios';
import { constants } from '../../Helpers/constantsFile';

/**
 * Station printers.
 *
 * The address lives on the server because it is the same from every device on
 * the shop WiFi — nothing about a printer record is specific to one till.
 *
 * Reads need only a sign-in; creating, editing and deleting are manager-only
 * on the server, which is why the screen sits under Administration.
 */

const auth = (token) => ({ headers: { Authorization: token } });

/** Inactive printers come back too — the list has to show them, greyed. */
export async function fetchPrinters({ businessId, token }) {
  const { data } = await axios.get(
    `${constants.baseUrl}/printers/get-business-printers/${businessId}`,
    auth(token)
  );
  return data?.data?.printers || [];
}

export async function createPrinter({ payload, token }) {
  const { data } = await axios.post(`${constants.baseUrl}/printers`, payload, auth(token));
  return data?.data?.printer;
}

export async function updatePrinter({ id, payload, token }) {
  const { data } = await axios.patch(
    `${constants.baseUrl}/printers/${id}`,
    payload,
    auth(token)
  );
  return data?.data?.printer;
}

/**
 * The server refuses while any category still points here, and its message
 * names how many. Let that message through untouched — it is more useful than
 * anything this side could invent.
 */
export async function deletePrinter({ id, token }) {
  await axios.delete(`${constants.baseUrl}/printers/${id}`, auth(token));
}

/* ── validation, shared by the dialog and anything else that writes one ─── */

export function validateHost(host) {
  const parts = String(host || '').trim().split('.');
  if (parts.length !== 4) return false;
  return parts.every((part) => {
    if (!/^\d{1,3}$/.test(part)) return false;
    const value = Number(part);
    return value >= 0 && value <= 255;
  });
}

export function validatePort(port) {
  const value = Number(port);
  return Number.isInteger(value) && value >= 1 && value <= 65535;
}
